export enum ECheckInClassification {
  Complete = 18,
  Prescription = 21
}
